module.exports = __webpack_public_path__ + "images/enterprise207fb94cc6233c1179dfb963d127a10f.png";